{
    "(save {highestYearlyDiscount}%)": "(заштеди {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} бесплатни денови",
    "{amount} off": "{amount} помалку",
    "{amount} off for first {number} months.": "{amount} помалку за првите {number} месеци.",
    "{amount} off for first {period}.": "{amount} помалку за првиот {period}.",
    "{amount} off forever.": "{amount} помалку, засекогаш.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% попуст",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "Билтенот за {newsletterName} нема веќе да се доставува на {memberEmail}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} нема веќе да добива пораки кога некој ќе одговори на вашиот коментар.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} нема веќе да го добива овој билтен.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} денови бесплатно",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Сметка",
    "Account details updated successfully": "",
    "Account settings": "Поставки",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Откако пробниот период ќе истече, ќе ви биде наплатена регуларната цена за пакетот кој сте го избрале. Секогаш можете да откажете претходно.",
    "Already a member?": "Веќе сте член",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Настана неочекувана грешка. Ве молиме обидете се повторно или <a>контактирајте ја подршката</a> ако грешката се повторува.",
    "Back": "Назад",
    "Back to Log in": "Назад кон најава",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Црн петок",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Откажете било кога.",
    "Cancel subscription": "Откажете претплата",
    "Canceled": "",
    "Cancellation reason": "Причина за откажување",
    "Change": "Променете",
    "Change plan": "",
    "Check spam & promotions folders": "Проверете спам и промотивни папки",
    "Check with your mail provider": "Проверете со вашиот mail сервис",
    "Check your inbox to verify email update": "",
    "Choose": "Изберете",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Изберете друг пакет",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Изберете ги вашите билтени",
    "Click here to retry": "Кликнете тука за да се обидите повторно",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Затворете",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Коментари",
    "Complimentary": "Дополнителен",
    "Confirm": "Потврдете",
    "Confirm cancellation": "Потврдете откажување",
    "Confirm subscription": "Потврдете претплата",
    "Contact support": "Контактирајте подршка",
    "Continue": "Продолжете",
    "Continue subscription": "Продолжете ја претплатата",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Не можете да се најавите. Линкот за најава истече.",
    "Could not update email! Invalid link.": "Не може да се промени email адресата! Линкот е невалиден.",
    "Create a new contact": "Создајте нов контакт",
    "Current plan": "Моментален пакет",
    "Delete account": "Избришете сметка",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Не мислевте да го сторите ова? Променете ги вашите поставки <button>тука</button>.",
    "Don't have an account?": "Немате сметка?",
    "Edit": "Променете",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Email билтен",
    "Email newsletter settings updated": "",
    "Email preferences": "Email поставки",
    "Email preferences updated.": "",
    "Emails": "Електронски пошти",
    "Emails disabled": "Оневозможени електронски пошти",
    "Ends {offerEndDate}": "Завршува на {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Грешка",
    "Expires {expiryDate}": "Истекува на {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Засекогаш",
    "Free Trial – Ends {trialEnd}": "Пробниот период - Истекува на {trialEnd}",
    "From": "",
    "Get help": "Побарајте помош",
    "Get in touch for help": "Стапете во контакт за помош",
    "Get notified when someone replies to your comment": "Добијте известување кога некој ќе одговори на вашиот коментар",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Оставете белешка за оваа објава",
    "Help! I'm not receiving emails": "Помош! Јас не добивам email пораки",
    "Here are a few other sites you may enjoy.": "Овие се неколку други страници кои може да ви се допаднат.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ако билтенот е обележан како спам, email пораките се автоматски оневозможени за таа email адреса, со цел веќе да не добивате непосакувани пораки.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ако поплаката за спам беше извршена несакајќи, или доколку сакате да добивате пораки повторно, можете повторно да се претплатите со кликнување на копчето на претходната страница.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ако ја откажете вашата претплата сега, ќе продолжите да имате пристап до {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ако имате службена или владина email сметка, контактирајте ги надлежните во вашиот ИТ оддел и побарајте им да ви овозможат примање на пораки од {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Линк за најава беше испратен кон вашиот email. Ако не пристигне за повеќе од 3 минути, проверете во спам.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Доколку сакате да добивате пораки повторно, најдобри наредни чекори се да ја проверите вашата email адреса за евентуални проблеми и потоа претплатете се повторно на претходниот екран.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Доколку не добивате пораки од билтенот на кој сте се претплатиле, овие се неколку нешта кои можете да ги проверите.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Доколку сте ги завршиле сите овие проверки и сè уште не добивате пораки, контактирајте на {supportAddress} за да добиете подршка.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Во случај кога настане траен неуспех при обид за испраќање на билтен, email пораките ќе бидат оневозможени за сметката.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Додајте го {senderEmail} во листата на контакти од вашиот email сервис додајте. Ова ќе му сигналира на вашиот email сервис дека пораките добиени од оваа email адреса треба да бидат прифатени.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Помалку како ова",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Осигурајте се дека пораките не завршуваат несакано во папките за спам или промоции од вашиот email. Доколку тоа се случува, обележете ги дека не се спам и префрлете ги во главното поштенско сандаче.",
    "Manage": "Управувајте",
    "Maybe later": "Можеби подоцна",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Зачленувањето не е достапно. За пристап контактирајте го сопственикот.",
    "month": "",
    "Monthly": "Месечно",
    "More like this": "Повеќе како ова",
    "More options": "",
    "Name": "Име",
    "Need more help? Contact support": "Ви треба помош? Контактирајте подршка",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Билтените можат да бидат оневозможени за вашата сметка поради две причини: претходна порака била обележана како спам, или обидот за исппраќање на порака резултирал со траен неуспех (отскокнување).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Не добивате пораки?",
    "Now": "",
    "Now check your email!": "Сега проверете ги пораките1",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Кога ќе се претплатите повторно, доколку сè уште не добивате пораки, проверте ја папката за спам. Некои сервиси чуваат записи од претходни поплаки за спам и продолжуваат да ги обележуваат пораките како такви. Ако ова се случи, обележете ја последната порака од билтенот дека не е спам и префрлете ја во главното поштенско сандаче.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Траен неуспех (отскокнување)",
    "Phone number": "",
    "Plan": "Пакет",
    "Plan checkout was cancelled.": "Плаќањето на пакетот беше откажано.",
    "Plan upgrade was cancelled.": "Надградбата на пакетот беше откажана.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Ве молиме контактирајте на {supportAddress} за прилагодување на вашата додатна претплата.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Ве молиме пополнете ги задолжителните полиња",
    "Podcasts": "",
    "Re-enable emails": "Овозможете пораки",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Препораки",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Обновувањето е {price}.",
    "Resume subscription": "",
    "Retry": "Обидете се повторно",
    "Save": "Зачувајте",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Испраќање на линкот за најава...",
    "Sending...": "Испраќање...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Прикажете сè",
    "Sign in": "Најавете се",
    "Sign out": "Одјавете се",
    "Sign up": "Регистрирајте се",
    "Signup error: Invalid link": "Грешка при регистрација: Невалиден линк",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Се извинуваме, тоа не проработи.",
    "Spam complaints": "Поплаки за спам",
    "Start {amount}-day free trial": "Започнете {amount} дневен пробен период",
    "Starting {startDate}": "Започнува на {startDate}",
    "Starting today": "Започнува денес",
    "Submit feedback": "Испратете забелешка",
    "Subscribe": "Претплатете се",
    "Subscribed": "Претплатено",
    "Subscription plan updated successfully": "",
    "Success": "Успех",
    "Success! Check your email for magic link to sign-in.": "Успех! Проверете го вашиот email за линк за најава.",
    "Success! Your account is fully activated, you now have access to all content.": "Успех! Вашата сметка е целосно активирана и сега имате пристап до целата содржина.",
    "Success! Your email is updated.": "Успех! Вашиот email е ажуриран.",
    "Successfully unsubscribed": "Успешно се отпишавте",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Ви благодариме за претплатувањето. Пред да започнете со читање, подолу се неколку други страници кои може да ви се допаднат.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Ви благодариме за забелешката!",
    "That didn't go to plan": "Тоа се случи според планот!",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Email адресата која ја имаме за вас е {memberEmail} - ако ова не е точна адреса, можете да ја ажурирате во <button>секцијата за поставки</button> на сметката.",
    "There was a problem submitting your feedback. Please try again a little later.": "Настана проблем при испраќање на вашата забелешка. Обидете се повторно малку подоцна.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Оваа страница е достапна само со покана. За пристап контактирајте го сопственикот.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "За да ја завршите регистрацијата, кликнете на линкот за потврда испратен на вашата email адреса. Ако не пристигне во рок од 3 минути, проверте во спам!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Пробајте бесплатно за {amount} денови, потоа по цена од {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Добијте пристап до сите билтени преку платена претплата.",
    "Unsubscribe from all emails": "Отпишете се од сите пораки",
    "Unsubscribed": "Отпишано",
    "Unsubscribed from all emails.": "Отпишани од сите пораки.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Отпишувањето од пораките нема да ја откаже платената претплата на {title}",
    "Update": "Ажурирај",
    "Update your preferences": "Ажурирајте ги поставките",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Линкот за потврда беше испратен. Проверете го вашиот email.",
    "Verify your email address is correct": "Потврете дека вашата email адреса е точна",
    "Verifying...": "",
    "View plans": "Видете пакети",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Ние не можевме да ве отпишеме бидејќи email адресата не беше пронајдена. Ве молиме контактирајте го сопственикот на страницата.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Добредојдовте назад, {name}!",
    "Welcome back!": "Добредојдовте назад!",
    "Welcome to {siteTitle}": "Добредојдовте на {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Кога email адреса не успева да добие порака, тоа се нарекува отскокнување. Во повеќе случаи, ова може да биде привремено. Но, во некои случаи, отскокнувањето може да биде вратено како траен неуспех кога email адресата е невалидна или непостоечка.",
    "Why has my email been disabled?": "Зошто мојата email адреса беше оневозможена?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Годишно",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Моментално имате бесплатно членство. Надградете на платена претплата за целосен пристап.",
    "You have been successfully resubscribed": "Бевте успешно претплатени повторно",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Моментално не добивате пораки",
    "You're not receiving emails": "Не добивате пораки",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Не добивате пораки бидејќи вие ја обележавте некоја од последните пораки како спам, или бидејќи пораките не можат да бидат доставени на адресата која ја доставивте.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Успешно се најавивте.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Успешно се претплативте на <strong>{siteTitle}</strong>",
    "Your account": "Вашата сметка",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Вашиот прилог помага да се оформи она кое ќе биде објавувано.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Вашата претплата ќе истече на {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Вашата претплата ќе биде обновена на {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Вашата претплата ќе започне на {subscriptionStart}"
}
